import { useTranslation } from 'react-i18next';

export default function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const current = i18n.language?.startsWith('en') ? 'en' : 'es';

  const change = (lang: 'es' | 'en') => {
    i18n.changeLanguage(lang);
  };

  return (
    <div
      role="group"
      aria-label={t('langLabel')}
      className="inline-flex items-center gap-1 rounded-full border border-foreground-200/25 bg-background-900/70 p-1 backdrop-blur"
    >
      <button
        type="button"
        onClick={() => change('es')}
        aria-pressed={current === 'es'}
        className={`rounded-full px-4 py-1.5 font-label text-xs md:text-sm font-semibold tracking-wider cursor-pointer whitespace-nowrap transition-colors ${
          current === 'es' ? 'bg-accent-500 text-background-950' : 'text-foreground-200 hover:text-foreground-50'
        }`}
      >
        {t('langEs')}
      </button>
      <button
        type="button"
        onClick={() => change('en')}
        aria-pressed={current === 'en'}
        className={`rounded-full px-4 py-1.5 font-label text-xs md:text-sm font-semibold tracking-wider cursor-pointer whitespace-nowrap transition-colors ${
          current === 'en' ? 'bg-accent-500 text-background-950' : 'text-foreground-200 hover:text-foreground-50'
        }`}
      >
        {t('langEn')}
      </button>
    </div>
  );
}